const classesForChartOdds = [
  'digit-1',
  'digit-2',
  'digit-3',
  'digit-4',
  'digit-5',
  'digit-6',
  'digit-7',
];

export function getClassByCountOfDigits(odd) {
  return classesForChartOdds[Math.trunc(odd).toString().length - 1];
}
